module.exports = __webpack_public_path__ + "static/25-31560a80c5c3ddaf670975d8edc6b476.jpg";